import { useSyncExternalStore } from 'react';
import { getConnectionStatus, subscribeConnectionStatus } from '@/observability/networkTelemetry';

/**
 * Estado atual da conexão: 'online' | 'offline' | 'unstable'.
 * Calculado em observability/networkTelemetry (eventos do navegador +
 * requisições lentas/sem resposta).
 */
export const useConnectionStatus = () =>
  useSyncExternalStore(subscribeConnectionStatus, getConnectionStatus);
